{
    "firstname": {
        "label": "Vorname",
        "required": true
    },
    "lastname": {
        "label": "Nachname",
        "required": true
    },
    "email": {
        "label": "E-Mail",
        "type": "email",
        "required": true
    },
    "company": {
        "label": "Firma"
    },
    "vat_id": {
        "label": "USt-Id"
    },
    "spacer": {
        "type": "spacer"
    },
    "address": {
        "label": "Straße und Hausnummer",
        "required": true
    },
    "zip": {
        "label": "PLZ",
        "classes": "uk-width-1-6@s",
        "required": true
    },
    "city": {
        "label": "Ort",
        "classes": "uk-width-1-3@s",
        "required": true
    },
    "country": {
        "type": "country",
        "label": "Land",
        "required": true
    }
}
